import React from 'react'
import styled from 'styled-components'

import CMS from '@talus-analytics/library.airtable-cms'
import useIndexPageData from '../../../cmsHooks/useIndexPageData'

import { Subheader } from '../../ui'
import { Center } from '../../layout'
import device from '../../../utilities/device'

const Number = styled.div`
  font-family: 'Overpass', 'Open Sans', Arial, Helvetica, sans-serif;
  font-size: 24;
  font-weight: 600;
  text-align: center;
  margin-bottom: 10px;
`
const CenteredText = styled.p`
  text-align: center;
  max-width: 380px;
  margin-bottom: 45px;
  margin-top: 15px;
  line-height: 1.4em;
  @media ${device.laptop} {
    margin-bottom: 20px;
  }
`
const CenteredColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`
interface ProcessStepProps {
  step: number
}

const ProcessStep = ({ step }: ProcessStepProps): JSX.Element => {
  const data = useIndexPageData()

  return (
    <CenteredColumn>
      <Number>0{step}</Number>
      <Subheader green center>
        <CMS.Text name={`Process ${step} title`} data={data} />
      </Subheader>
      <CenteredText>
        <CMS.Text name={`Process ${step} description`} data={data} />
      </CenteredText>
      <Center cross>
        <CMS.Image name={`Process ${step} image`} data={data} />
      </Center>
    </CenteredColumn>
  )
}
export default ProcessStep
